"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastSeenHotels = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const LastSeenHotelItem_1 = __importDefault(require("./LastSeenHotelItem"));
const LastSeenHotelsWrapper = styled_components_1.default.div(({ theme }) => theme.lastSeenHotels.lastSeenHotelsWrapper);
const LastSeenHotelsTitle = styled_components_1.default.h3(({ theme }) => theme.lastSeenHotels.lastSeenHotelsTitle);
const LastSeenHotelsCards = styled_components_1.default.ul(({ theme }) => theme.lastSeenHotels.lastSeenHotelsCards);
const LastSeenHotels = ({ lastSeenHotels, title, ratingContent, remainRatingContent, lastSeenHotelItemFooter, openInNewPage, locationsSeparator, trackClick, }) => {
    return (react_1.default.createElement(LastSeenHotelsWrapper, { className: "last-seen-hotels-wrapper" },
        react_1.default.createElement(LastSeenHotelsTitle, null, title),
        react_1.default.createElement(LastSeenHotelsCards, null, lastSeenHotels.map(lastSeenHotel => {
            return (react_1.default.createElement(LastSeenHotelItem_1.default, { key: lastSeenHotel.productName, lastSeenHotel: lastSeenHotel, ratingContent: ratingContent, remainRatingContent: remainRatingContent, lastSeenHotelItemFooter: lastSeenHotelItemFooter, openInNewPage: openInNewPage, locationsSeparator: locationsSeparator, trackClick: trackClick }));
        }))));
};
exports.LastSeenHotels = LastSeenHotels;
//# sourceMappingURL=LastSeenHotels.js.map